import React, { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import PageLoader from '../PageLoader';
import ImageLoad from '../ImageLoad';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Notification = () => {
    const { t } = useTranslation();
    const { BaseUrl, handleCallApi } = useContext(MyContext);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [notificationList, setNotificationList] = useState([]);

    const FetchRef = useRef(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        handleFetchData();
    }, []);

    const categorizeNotification = (title = '', description = '') => {
        const text = `${title} ${description}`.toLowerCase();
        const rideKeywords = ['ride', 'booking', 'captain', 'driver', 'assigned', 'arrived', 'started', 'completed', 'cancelled', 'otp', 'bid', 'destination'];
        const offerKeywords = ['offer', 'discount', 'promo', 'coupon', 'code', 'off', 'deal', 'free', 'reward', 'referral'];
        const walletKeywords = ['wallet', 'payment', 'paid', 'amount', 'transaction', 'added', 'refund', 'charge', 'balance', 'deposit', 'withdrawal', 'money'];

        if (rideKeywords.some(keyword => text.includes(keyword))) {
            return 'ride_updates';
        }
        if (offerKeywords.some(keyword => text.includes(keyword))) {
            return 'offers';
        }
        if (walletKeywords.some(keyword => text.includes(keyword))) {
            return 'wallet_payment';
        }
        return 'support_admin';
    };

    const handleFetchData = async () => {
        if (FetchRef.current) return;
        FetchRef.current = true;
        const uid = secureLocalStorage.getItem("Userid");
        const Respose = await handleCallApi("Post", "customer/notification", { uid });
        
        let userPrefs = { ride_updates: true, offers: true, wallet_payment: true, support_admin: true };
        if (uid) {
            const savedPrefs = localStorage.getItem(`notification_prefs_${uid}`);
            if (savedPrefs) {
                try {
                    userPrefs = JSON.parse(savedPrefs);
                } catch (e) {
                    console.error("Error parsing notification preferences:", e);
                }
            }
        }

        if (Respose && Respose.data && Respose.data.ndata) {
            const filtered = Respose.data.ndata.filter(item => {
                const category = categorizeNotification(item.title, item.description);
                return userPrefs[category] !== false;
            });
            setNotificationList(filtered);
        }
        setLoading(false);
    }

    return (
        <div>

            <div className='max-w-2xl mx-auto p-3'>
                <h1 className="font-bold text-[30px] mb-5">{t("Notification")}</h1>

                {!loading && notificationList.length === 0 ? (
                    <div className="text-center py-12 px-4 bg-white rounded-2xl shadow border border-gray-150 flex flex-col items-center">
                        <div className="w-16 h-16 bg-blue-50 text-[--bg-color] rounded-full flex items-center justify-center mb-4">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z" fill="currentColor"/>
                            </svg>
                        </div>
                        <h2 className="text-xl font-bold text-gray-900 mb-2">{t("No Notifications Yet")}</h2>
                        <p className="text-gray-500 mb-6 max-w-sm">{t("We will keep you updated with news and active trip details.")}</p>
                        <button onClick={() => navigate("/")} className="bg-[--bg-color] text-white px-6 py-2.5 rounded-xl font-semibold hover:opacity-90 active:scale-95 duration-150 shadow-md">
                            {t("Go Home")}
                        </button>
                    </div>
                ) : (
                    <div className="space-y-4">
                        {notificationList.map((item, index) => (
                            <motion.div key={index}
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.10 }}
                                className="shadow p-4 rounded-[10px] flex items-center gap-4 bg-white border border-gray-100">
                                <ImageLoad src={BaseUrl + item.image} CustomeStyle={"w-[50px] h-[50px] flex-shrink-0"} ImagStyle={"w-full h-full object-contain"} alt={"notification img"} status={false} />
                                <div className="leading-5">
                                    <h1 className='font-semibold text-gray-900'>{item.title}</h1>
                                    <p className='text-[15px] leading-5 text-gray-600 mt-1'>{item.description}</p>
                                    <span className='text-[14px] text-gray-400 mt-2 block'>{item.date}</span>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                )}

            </div>

            <PageLoader loading={loading} />
        </div>
    )
}

export default Notification